import { RouteConfig } from "vue-router";
import { IRouterConfig } from "@/types";

import userRoutes from "./user";
import adminRoutes from "./admin";
import publicRoutes from "./public";
import sharedRoutes from "./shared";
import personalLiabilityPolicyRoutes from "./admin/personalLiabilityPolicyRoutes";
import { redirectHomeRoute } from "../middleware";
import { userRoleArr } from "@/helpers/selectOptions";

const moduleName = "404";
const wildcardRoute: IRouterConfig = {
  path: "*",
  component: () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/error/${moduleName}.vue`
    ),
  meta: {
    requireAuth: false
  }
};

const rootRoute: IRouterConfig = {
  path: "/",
  component: () =>
    import(/* webpackChunkName: "Dashboard" */ "@/views/user/Entry.vue"),
  meta: {
    requireAuth: true,
    allowedRoles: userRoleArr,
    beforeResolve: redirectHomeRoute
  }
};

const routers: RouteConfig[] = [
  ...personalLiabilityPolicyRoutes,
  ...sharedRoutes,
  ...publicRoutes,
  ...adminRoutes,
  ...userRoutes,
  wildcardRoute,
  rootRoute
];

export default routers;
